/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import CaseOverviewRow from './CaseOverviewRow';

type CaseOverviewRowsProps = {
  children: any,
  router: Object
}

let CaseOverviewRows = ({
  children: { reportsByDate }, router
}: CaseOverviewRowsProps): React.Element => {
  return (
    TBody({
      children: Object.keys(reportsByDate).map(key => (
        <CaseOverviewRow
          key={ key }
          report={ reportsByDate[key] }
          router={ router }
        >
         { key }
        </CaseOverviewRow>
      ))
    })
  );
};

export default CaseOverviewRows;
